const fields = {
  name: new Set([
    'dropoffContact.identity.name',
    'Customer.Name',
    'pkg.receiverName',
    'recipient_data.name',
    'dropOff.contactName',
    'destinationAddress.name',
    'client.name',
    'client.arName',
    'delivery_name',
    'customer_name',
    'dropoff_name',
    'receiver.name',
    'to_address.name',
    'Consignee.Contact.CompanyName',
    'Consignee.Contact.PersonName',
    'data.recipient_data.name',
    'data.actual_recipient_name',
    'receiverName',
    'receiverFirstName',
    'shipping.delivery_name',
    'fullReceiverName',
    'Shipment.receiver.name',
  ]),

  phone: new Set([
    'dropoffContact.identity.phone',
    'Customer.Mobile',
    'pkg.receiverPhone',
    'pkg.receiverPhone2',
    'recipient_data.phone',
    'dropOff.contactMobile',
    'destinationAddress.phoneNumber',
    'client.phoneNumber',
    'client.phone',
    'delivery_phone',
    'customer_phone',
    'dropoff_phone',
    'receiver.phone',
    'receiver.phone2',
    'to_address.phone',
    'Consignee.Contact.PhoneNumber1',
    'Consignee.Contact.CellPhone',
    'data.recipient_data.phone',
    'receiverPhone',
    'receiverPhone2',
    'shipping.delivery_phone',
    'Shipment.receiver.phone',
    'Shipment.receiver.phone2',
  ]),
};

export function maskSensitiveData(data) {
  function traverse(obj, path = '') {
    if (Array.isArray(obj)) {
      return obj.map((item, index) => traverse(item, `${path}[${index}]`));
    }

    if (obj && typeof obj === 'object') {
      const result = {};
      for (const key in obj) {
        const currentPath = path ? `${path}.${key}` : key;
        const value = obj[key];
        if (typeof value === 'string') {
          if (shouldMask(currentPath, fields.name)) {
            result[key] = maskName(value);
          } else if (shouldMask(currentPath, fields.phone)) {
            result[key] = maskPhone(value);
          } else {
            result[key] = value;
          }
        } else if (typeof value === 'number' || typeof value === 'boolean') {
          result[key] = result[key] = value;
        } else {
          result[key] = traverse(value, currentPath);
        }
      }
      return result;
    }

    return obj;
  }

  return traverse(data);
}

export function shouldMask(currentPath, paths) {
  return paths.has(currentPath);
}

export function maskName(name) {
  return name
    .split(/\s+/)
    .map((word) => word[0] + '*'.repeat(word.length - 1))
    .join(' ');
}

export function maskPhone(phone) {
  const digits = phone.replace(/\D/g, '');
  if (digits.length < 4) return phone;
  return phone.replace(digits, '*'.repeat(digits.length - 4) + digits.slice(-4));
}
